import axios from "axios";
import { Component } from "react";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

export default class SettingWebService extends Component {
  
  //No use
  static async getFEScreenSetting(
    token,
    entity
  ) {
    let header=await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/list`);
    let resp = await axios.post(
      url,
      {
        id: "df-frontend-scr-setting-list",
        bypassRowsOfPage: true
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
}
